import { render, staticRenderFns } from "./Product-XXNL.vue?vue&type=template&id=55396050&scoped=true"
import script from "./Product-XXNL.vue?vue&type=script&lang=js"
export * from "./Product-XXNL.vue?vue&type=script&lang=js"
import style0 from "./Product-XXNL.vue?vue&type=style&index=0&id=55396050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55396050",
  null
  
)

export default component.exports